export const TYPES_ROOT_DIR = 'types';
export const GENERATED_OUT_DIR = 'generated';
